export default require('../otherChains/injectiveTestnet').default.rpcUrls.default.http[0]